import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { CrossReference } from '../../../../types/product/product';
import { User } from '../../../../types/user/user';
import { CrossReferenceType } from '../../../../types/contract/contract-product-cross-reference.enums';

export interface CrossReferencesOptionsRendererParams
  extends ICellRendererParams {
  userAccount: User;
  promoteCross: (crossReference: CrossReference) => {};
  removeCross: (crossReference: CrossReference) => {};
}

@Component({
    selector: 'app-cross-references-options-renderer',
    templateUrl: './cross-references-options-renderer.component.html',
    styleUrls: ['./cross-references-options-renderer.component.scss'],
    standalone: false
})
export class CrossReferencesOptionsRendererComponent
  implements ICellRendererAngularComp
{
  crossReference!: CrossReference;
  userAccount!: User;
  onPromoteCross = (crossReference: CrossReference) => {};
  onRemoveCross = (crossReference: CrossReference) => {};

  agInit(params: CrossReferencesOptionsRendererParams): void {
    this.crossReference = params.data;
    this.userAccount = params.userAccount;
    this.onPromoteCross = params.promoteCross;
    this.onRemoveCross = params.removeCross;
  }

  refresh(): boolean {
    return false;
  }

  isOwnProduct() {
    return (
      this.userAccount.organization.id === this.crossReference?.createdByOrg?.id
    );
  }

  // Promote Logic
  canPromote() {
    return (
      !this.isPrimary() &&
      this.crossReference.crossReferenceType !== CrossReferenceType.NO_MATCH
    );
  }

  private isPrimary() {
    return (
      this.crossReference.crossReferenceType === CrossReferenceType.PRIMARY
    );
  }
}
